import { useTranslation } from 'hooks/use-translation';
import React, { FC, useEffect, useRef } from 'react';
import styles from './styles.scss';
import { appointmentSource } from '@services/test-form';
import { setOpenHomeTime, getOpenHomeTime } from '@utils/testForm';

type IProps = {
	onClick?: () => void;
};

const AppointmentSection: FC<IProps> = (props) => {
	const { onClick } = props;
	const { transData } = useTranslation('home.appointment');
	const timeVal = useRef(0);

	//测试弹窗--接口埋点 pv
	useEffect(() => {
		const time = getOpenHomeTime();
		appointmentSource({ eventType: 1, landingPageId: 1, duration: time ? new Date().getTime() - Number(time) : undefined });
		setOpenHomeTime();
	}, []);

	//接口埋点 uv
	useEffect(() => {
		timeVal.current = new Date().getTime();
		return () => {
			if (timeVal.current) {
				appointmentSource({ eventType: 1, landingPageId: 1, duration: new Date().getTime() - timeVal.current });
			}
		};
	}, []);

	return (
		<section className={styles['ac-appointment']} id="appointment">
			<div className={styles['ac-appointment-container']}>
				<img className={styles['appointment-img-3']} loading="lazy" src={transData.banner_text} alt="" />
				<div className={styles['appointment-action']}>
					<img onClick={onClick} className={styles['appointment-img-4']} loading="lazy" src={transData.button} alt="" />
					<span className={styles['hand']}></span>
				</div>
				<img
					className={styles['appointment-img-2']}
					loading="lazy"
					src="https://web-data.zmlearn.com/image/uwXhz5grSxHuvCA6bb5cPV/banner_home%402x.png"
					alt=""
				/>
			</div>
		</section>
	);
};

export default AppointmentSection;
